var link_viewer_default = {
  "fontElementMap": "a0Qd-",
  "link": "W2DLT",
  "linkInEditor": "hyH8Q",
  "linkInViewer": "Cixha",
  "toolbarUrlContainer": "Iw5zC",
  "toolbarUrl": "VFb4i",
  "toolbarUrlAnchor": "_6BYIv"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
